import { combineReducers } from 'redux';

import auth from '../modules/auth/store/reducer';
import contractors from '../modules/contractors/store/reducer';
import layout from '../layout/store/reducers';
import app from './appReducer';

export default combineReducers({ app, auth, contractors, layout });
